import { useEffect } from "react";

/** Tiny utility that listens for the Escape key and triggers a callback. */
export default function EscListener({ onEscape }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onEscape?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onEscape]);
  return null;
}
